<template>
  <div>
    <HomeHeader />
    <div style="padding-top: 70px;width: 100%;">
      <el-container >
        <el-aside style="width: 10%"></el-aside>
        <el-main style="padding: 20px 29px;background-color: #FFFFFF;margin: 20px 0">
          <el-form ref="form" label-position="left" :rules="rules" label-width="90px" :model="form" style="font-size: 14px">
            <el-form-item label="所在频道:" prop="channelId">
              <el-select v-model="form.channelId"  placeholder="请选择频道" style="width: 246px;" @change="$forceUpdate()">
                <el-option
                    v-for="item in channelList"
                    v-show="item.status == 1"
                    :key="'channel' + item.id"
                    :label="item.name"
                    :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="文章标题:" prop="title">
              <el-input v-model="form.title" show-word-limit maxlength="50" style="width: 246px;"></el-input>
            </el-form-item>
            <el-form-item label="文章内容:" prop="text">
              <el-input v-model="form.text" style="display: none"></el-input>
              <quill-editor
                  ref="myQuillEditor"
                  v-model="form.content"
                  class="ql"
                  :options="editorOption"
              />
            </el-form-item>
            <el-form-item label="标签:" prop="tags">
              <el-input v-model="form.tags" style="display: none"></el-input>
              <div style="display: flex;align-items: center;height: 40px">
                <div v-for="(item, index) in form.tags" :key="'tag' + index" class="selectedTab">
                  {{item}}
                <i class="el-icon-error" style="color:#3E3E3E;font-size: 13px;cursor: pointer" @click="delTag(item)"></i>
                </div>
                <el-popover
                    v-model="visible"
                    placement="bottom"
                    @after-enter="autofocusHandler('tagFocus')"
                    width="650">
                  <div style="display: flex;align-items: center;padding: 10px;margin-bottom: 10px;flex-wrap: wrap;max-height: 95px;overflow-y: auto">
                    <div
                        v-for="(item, index) in tabList"
                        :key="'tab' + index"
                        :class=" form.tags.indexOf(item.tagName) === -1 ? '' : 'choiceTab'"
                        class="tab"
                        @click="selectTab(item.tagName)"
                    >{{item.tagName}}</div>
                  </div>
                  <el-form-item label="自定义标签" style="width: 100%">
                    <el-input ref="tagFocus" v-model="newTag" show-word-limit maxlength="10" size="small" style="width: 450px;"></el-input>
                    <el-button size="small" type="primary" style="width: 96px;margin-left: 6px" @click="addTag">添加</el-button>
                    <el-button size="small" type="primary" style="width: 96px;margin-left: 6px" @click="autofocusHandler('tagFocus')">测试</el-button>
                  </el-form-item>
                  <div v-show="form.tags.length < 5" slot="reference" class="tab_button">
                    <i class="el-icon-plus"></i>
                    添加标签，最多添加5个
                  </div>
                </el-popover>
              </div>
            </el-form-item>
            <el-form-item>
              <el-button v-if="test()" type="primary" style="width: 96px" plain @click="save">保存草稿</el-button>
              <el-button type="primary" style="width: 96px" plain @click="draft">预览</el-button>
              <el-button type="primary" style="width: 96px" @click="release">{{ releaseButtonName }}</el-button>
            </el-form-item>
          </el-form>
        </el-main>
        <el-aside style="width: 10%"></el-aside>
      </el-container>
    </div>
    <el-dialog
        title=""
        :before-close="cancelLoad"
        :visible.sync="dialogVisible"
        width="30%">
      <span>是否加载上次保存的草稿</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="loadLastArticle()">确 定</el-button>
        <el-button @click="cancelLoad()">取 消</el-button>
      </span>
    </el-dialog>
    <el-dialog title="" :visible.sync="dialogVisibleDraft" width="100%" top>
      <draftNew ref="child" style="padding-right:10px;">
      </draftNew>
    </el-dialog>
    <HomeFooter style="margin-top:0;"/>
  </div>
</template>

<script>
import draftNew from '../draft/index.vue'
import HomeHeader from '../../../components/HomeHeader'
import HomeFooter from '../../../components/HomeFooter'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { quillEditor, Quill } from 'vue-quill-editor'
import { articleAdd, channelFind, getLabel, getArticle, findAll, delArticle, updateArticle, updateArticleStatus } from '@/api/modules/forum'
import { getUploadKey } from '@/api/modules/api'
import COS from 'cos-js-sdk-v5'
import imageCompress from 'quill-image-compress'
import ImageResize from '@taoqf/quill-image-resize-module'
import quillEmoji from 'quill-emoji'
import 'quill-emoji/dist/quill-emoji.css'
const fontSizeStyle = Quill.import('attributors/style/size')
// fontSizeStyle.whitelist = ['10px', '12px', '14px', '16px', false, '20px', '22px', '24px', '26px', '28px', '30px', '32px', '36px', '38px', '40px', '45px', '50px']
fontSizeStyle.whitelist = ['14px', '16px', '18px', '20px', '22px', '24px', '26px', '28px', '30px', '32px', '36px', false]
Quill.register(fontSizeStyle, true)
Quill.register('modules/imageCompress', imageCompress)
Quill.register('modules/imageResize', ImageResize)
Quill.register('modules/quillEmoji', quillEmoji)
export default {
  name: 'ForumEdit',
  components: {
    HomeHeader,
    quillEditor,
    HomeFooter,
    draftNew
  },
  data() {
    return {
      dialogVisible: false,
      dialogVisibleDraft: false,
      visible: false,
      form: {
        channelId: '',
        title: '',
        content: '',
        tags: [],
        text: ''
      },
      newTag: '',
      rules: {
        title: [
          { required: true, message: '请输入文章名称', trigger: 'change' }
        ],
        channelId: [
          { required: true, message: '请选择所在频道', trigger: 'change' }
        ],
        text: [
          { required: true, message: '文章内容不能为空', trigger: 'change' },
          { min: 11, max: 20000, message: '长度在 10 到 20000 个字符', trigger: 'change' }
        ]
      },
      editorOption: {
        placeholder: '请输入详情内容，不少于10个字',
        modules: {
          // 粘贴图片
          imageCompress: {
            quality: 0.7, // Image quality range: 0.0 - 1.0, default 0.7
            maxWidth: 1000, // Maximum width of images (in pixels), default 1000
            maxHeight: 800, // Maximum height of images (in pixels), default 1000
            imageType: 'image/jpeg', // default
            keepImageTypes: ['image/gif', 'image/jpeg', 'image/jpg', 'image/bmp', 'image/png'],
            ignoreImageTypes: ['image/gif'],
            debug: true, // default
            suppressErrorLogging: false, // default
            insertIntoEditor: (imageBase64URL, imageBlob, editor) => {
              const fileName = 'image.' + imageBlob.type.split('/')[1]
              const file = new File([imageBlob], fileName, { type: imageBlob.type })
              this.logoUrlCutomUpload({ file })
            }
          },
          imageResize: {},
          'emoji-toolbar': true,
          'emoji-shortname': true,
          // 工具栏选项
          toolbar: {
            container: [
              [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
              [{ 'size': fontSizeStyle.whitelist }],
              [{ 'color': [] }, { 'background': [] }],
              [{ 'list': 'bullet' }, { 'list': 'ordered' }],
              [{ 'indent': '-1' }, { 'indent': '+1' }],
              [{ 'clean': '源码编辑' }],
              ['link', 'image'],
              [{ 'header': 1 }, { 'header': 2 }],
              ['blockquote', 'code-block'],
              ['bold', 'italic', 'underline', 'strike'],
              [{ 'script': 'sub' }, { 'script': 'super' }],
              [{ 'align': '' }, { 'align': 'center' }, { 'align': 'right' }, { 'align': 'justify' }],
              ['emoji']
            ]
          }
        }
      },
      // editorOption: {
      //   modules: {
      //     clipboard: {
      //       // 粘贴版，处理粘贴时候带图片
      //       matchers: [[Node.ELEMENT_NODE, this.handleCustomMatcher]]
      //     },
      //     toolbar: [
      //       ['bold', 'italic', 'underline', 'strike'], // toggled buttons
      //       ['blockquote', 'code-block'],

      //       [{ 'header': 1 }, { 'header': 2 }], // custom button values
      //       [{ 'list': 'ordered' }, { 'list': 'bullet' }],
      //       [{ 'script': 'sub' }, { 'script': 'super' }], // superscript/subscript
      //       [{ 'indent': '-1' }, { 'indent': '+1' }], // outdent/indent
      //       [{ 'direction': 'rtl' }], // text direction

      //       [{ 'size': fontSizeStyle.whitelist }], // custom dropdown
      //       [{ 'header': [1, 2, 3, 4, 5, 6, false] }],

      //       [{ 'color': [] }, { 'background': [] }], // dropdown with defaults from theme
      //       [{ 'font': [] }],
      //       [{ 'align': [] }],
      //       ['image', 'link']
      //     ]
      //   },
      //   placeholder: '请输入详情内容，不少于10个字'
      // },
      channelList: [],
      tabList: [],
      addRange: '',
      lastArticle: {
        id: '',
        channelId: '',
        title: '',
        content: '',
        tags: [],
        text: ''
      },
      lastArticleId: '',
      isDraft: false,
      id: this.$route.query.id,
      releaseButtonName: '发布'
    }
  },
  computed: {
    editor() {
      return this.$refs.myQuillEditor.quill
    }
  },
  provide() {
    return {
      closeDialog: this.closeDialog
    }
  },
  watch: {
    'form.content': function(newV, oldV) {
      this.form.text = this.editor.getText()
    }
  },
  created() {
    this.channelFind()
    this.getLabel()
    if (this.id) {
      this.detail()
    }
    else {
      if (localStorage.getItem('draft')) {
        this.isDraft = true
        this.form = JSON.parse(localStorage.getItem('draft'))
        this.lastArticleId = this.form.id ? this.form.id : ''
        const content = this.form.content
        console.log(content)
        this.form.content = ''
        this.$nextTick(() => {
          document.querySelector('div.ql-editor').innerHTML = content
        })
        localStorage.removeItem('draft')
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      if (!this.id) {
        if (!this.isDraft) {
          this.findAll()
        }
      }
    })
    this.initButton()
  },
  updated() {
    this.form.text = this.editor.getText()
  },
  methods: {
    closeDialog() {
      this.dialogVisibleDraft = false
    },
    test() {
      // console.log('打印form.id：')
      // console.log(!this.form.id)
      // console.log('打印lastArticleId：')
      // console.log(this.lastArticleId !== '')
      // console.log('打印返回结果：')
      // console.log(!this.form.id || this.lastArticleId !== '')
      // console.log('-------------------------------------------------------')
      return !this.form.id || this.lastArticleId !== ''
    },
    initButton() {
      document.querySelector('.ql-italic').title = '倾斜\n将所选内容字体设置为倾斜'
      document.querySelector('.ql-underline').title = '下划线\n给所选文字内容添加下划线'
      document.querySelector('.ql-strike').title = '删除线\n给所选文字内容添加删除线'
      document.querySelectorAll('.ql-picker-item')[0].title = '字符样式\n将所选内容设置为标题1样式'
      document.querySelectorAll('.ql-picker-item')[1].title = '字符样式\n将所选内容设置为标题2样式'
      document.querySelectorAll('.ql-picker-item')[2].title = '字符样式\n将所选内容设置为标题3样式'
      document.querySelectorAll('.ql-picker-item')[3].title = '字符样式\n将所选内容设置为标题4样式'
      document.querySelectorAll('.ql-picker-item')[4].title = '字符样式\n将所选内容设置为标题4样式'
      document.querySelectorAll('.ql-picker-item')[5].title = '字符样式\n将所选内容设置为标题4样式'
      document.querySelectorAll('.ql-picker-item')[6].title = '字符样式\n将所选内容设置为正文样式'
      document.querySelectorAll('.ql-header')[2].title = '字符样式\n将所选内容设置为标题1样式'
      document.querySelectorAll('.ql-header')[3].title = '字符样式\n将所选内容设置为标题2样式'
      document.querySelectorAll('.ql-list')[0].title = '项目符号\n给所选段落添加项目符号'
      document.querySelectorAll('.ql-list')[1].title = '编号格式\n给所选段落添加编号'
      document.querySelectorAll('.ql-script')[0].title = '下标\n在文本行下方添加小字符'
      document.querySelectorAll('.ql-script')[1].title = '上标\n在文本行上方添加小字符'
      document.querySelectorAll('.ql-indent')[0].title = '减少缩进量\n减少段落缩进量'
      document.querySelectorAll('.ql-indent')[1].title = '增加缩进量\n增加段落缩进量'
      document.querySelector('.ql-color').title = '字体颜色\n设置文字的颜色'
      document.querySelector('.ql-background').title = '字符底纹\n给所选内容添加底纹'
      document.querySelectorAll('.ql-align')[0].title = '左对齐\n段落左对齐'
      document.querySelectorAll('.ql-align')[1].title = '居中对齐\n段落居中对齐'
      document.querySelectorAll('.ql-align')[2].title = '右对齐\n段落右对齐'
      document.querySelectorAll('.ql-align')[3].title = '两端对齐\n将文字左右两端同时进\n行对齐，并根据需要增\n加字间距'
      document.querySelector('.ql-bold').title = '加粗\n将所选内容字体加粗'
      document.querySelector('.ql-clean').title = '清除文本格式\n清除所选内容的文本格式'
      document.querySelector('.ql-link').title = '插入链接\n对所选内容添加链接'
      document.querySelector('.ql-video').title = '插入视频\n在所选区域添加视频'
      document.querySelector('.ql-fullscreen1').title = '全屏\n编辑区域最大化，再次点击撤销最大化'
      document.querySelector('.ql-sourceEditor').title = '插入素材\n在所选位置插入素材'
      document.querySelector('.ql-sourceEditorInsertFile').title = '导入文档\n在所选位置导入文档'
      document.querySelector('.ql-blockquote').title = '引用\n将所选内容设置为引用'
    },
    cancelLoad() {
      this.dialogVisible = false
    },
    async delArticle() {
      const res = await delArticle(this.lastArticleId)
      console.log(res)
    },
    loadLastArticle() {
      this.form = this.lastArticle
      const content = this.form.content
      this.form.content = ''
      this.$nextTick(() => {
        document.querySelector('div.ql-editor').innerHTML = content
      })
      this.dialogVisible = false
    },
    async findAll() {
      const data = {
        authorId: this.getCookie('userid'),
        status: 0
      }
      const res = await findAll(data)
      if (res.code === 0) {
        if (res.data.length > 0) {
          this.lastArticleId = res.data[0].id
          this.lastArticle.id = res.data[0].id
          this.lastArticle.content = res.data[0].content
          this.lastArticle.title = res.data[0].title
          this.lastArticle.tags = res.data[0].tags
          this.lastArticle.channelId = res.data[0].channelIds[0]
          this.dialogVisible = true
        }
      }
    },
    async logoUrlCutomUpload(data) {
      console.log(data)
      const { file } = data
      const res = await getUploadKey(0)
      const cosKey = res.data
      const cosKlg = new COS({
        getAuthorization: (options, callback) => {
          callback({
            TmpSecretId: cosKey.secretId,
            TmpSecretKey: cosKey.secretKey,
            XCosSecurityToken: cosKey.token,
            ExpiredTime: cosKey.expireTime
          })
        }
      })
      const key = 'web/img/' + new Date().getTime() + '-' + file.name
      cosKlg.putObject({
        Bucket: cosKey.bucket, // 指定桶参数coskey参
        Region: cosKey.region,
        Key: key, // this.sourcePath
        ContentType: 'application/octet-stream',
        StorageClass: 'STANDARD',
        Body: file,
        onProgress: function(progressData) {
          console.log(JSON.stringify(progressData))
        }
      }, (err, data) => {
        // this.catalogueProperties.newLogoKey = key
        this.addRange = this.editor.getSelection()
        // 调用编辑器的 insertEmbed 方法，插入图片URL到编辑器图片对应位置
        // 第一个参数index 光标位置索引
        this.editor.insertEmbed(
          this.addRange !== null ? this.addRange.index : 0,
          'image',
          'http://' + data.Location
        )
        console.log(err || data)
      })
    },
    draft() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          const data = this.channelList.filter((channel) => {
            return channel.id === this.form.channelId
          })
          this.form.channelName = data[0].name
          localStorage.setItem('draft', JSON.stringify(this.form))
          // this.$router.push('/forum/draft')
          this.dialogVisibleDraft = true
          this.$refs.child.form = JSON.parse(JSON.stringify(this.form))
        }
        else {
          console.log('error submit!!')
          return false
        }
      })
    },
    async detail() {
      const res = await getArticle(this.id)
      this.form = res.data
      this.$set(this.form, 'text', '')
      this.form.text = this.form.content
      const content = this.form.content
      this.form.content = ''
      this.$nextTick(() => {
        document.querySelector('div.ql-editor').innerHTML = content
      })
      this.form.channelId = JSON.parse(JSON.stringify(res.data.channelIds[0]))
      this.releaseButtonName = '修改'
    },
    async updateArticle() {
      const data = this.form
      data.channelIds = [this.form.channelId]
      // data.status = '2'
      data.authorId = this.getCookie('userid')
      const res = await updateArticle(data)
      if (res.code === 0) {
        this.$message({
          message: `发布成功`,
          type: 'success',
          offset: 80
        })
        if (data.state !== '2') {
          await updateArticleStatus({ status: '2', id: this.form.id })
        }
        await this.$router.push('/forum')
      }
      else {
        this.$message({
          message: res.msg,
          type: 'error',
          offset: 80
        })
      }
    },
    release() {
      this.rules.channelId[0].required = true
      this.$refs['form'].validate((valid) => {
        if (valid) {
          if (this.form.id) {
            this.updateArticle()
            return
          }
          this.add(2)
        }
        else {
          console.log('error submit!!')
          return false
        }
      })
    },
    save() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          if (this.lastArticleId !== '') {
            this.$confirm('保存后将覆盖上次的内容', '', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.delArticle()
              this.add(0)
            }).catch(() => {
              console.log(1)
            })
            return
          }
          this.add(0)
        }
        else {
          console.log('error submit!!')
          return false
        }
      })
    },
    selectTab(name) {
      if (this.form.tags.indexOf(name) !== -1) {
        return
      }
      if (this.form.tags.length === 5) {
        this.$message({
          message: '最多添加五个标签',
          type: 'warning',
          offset: 80
        })
        return
      }
      this.form.tags.push(name)
    },
    delTag(name) {
      this.$delete(this.form.tags, this.form.tags.indexOf(name))
    },
    addTag() {
      if (!this.newTag) {
        this.$message({
          message: '自定义标签名不能为空',
          type: 'warning',
          offset: 80
        })
        return
      }
      if (this.form.tags.indexOf(this.newTag) !== -1) {
        this.$message({
          message: '该标签已存在',
          type: 'warning',
          offset: 80
        })
        return
      }
      if (this.form.tags.length === 5) {
        this.$message({
          message: '最多添加五个标签',
          type: 'warning',
          offset: 80
        })
        return
      }
      this.form.tags.push(this.newTag)
      this.visible = false
      this.newTag = ''
    },
    async add(status) {
      const data = this.form
      data.status = status
      data.channelIds = [this.form.channelId]
      data.authorId = this.getCookie('userid')
      const res = await articleAdd(data)
      if (res.code === 0) {
        const text = status === 0 ? '保存' : '发布'
        this.$message({
          message: `${text}成功`,
          type: 'success',
          offset: 80
        })
        await this.$router.push('/forum')
      }
      else {
        this.$message({
          message: res.msg,
          type: 'error',
          offset: 80
        })
      }
    },
    async channelFind() {
      const data = {}
      const res = await channelFind(data)
      if (res.code === 0) {
        this.channelList = res.data
      }
    },
    getCookie(cname) {
      var name = cname + '='
      var ca = document.cookie.split(';')
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i]
        while (c.charAt(0) === ' ') c = c.substring(1)
        if (c.indexOf(name) !== -1) {
          return c.substring(name.length, c.length)
        }
      }
      return ''
    },
    async getLabel() {
      const data = {
        status: 1,
        tagGroupId: '1039488321722957824',
        pageSize: 1000
      }
      const res = await getLabel(data)
      if (res.code === 0) {
        this.tabList = res.data.dataList
      }
    },
    autofocusHandler(targetRef) {
      console.log(targetRef, this.$refs[targetRef])
      if (this.$refs[targetRef]) {
        this.$refs[targetRef].focus()
      }
    }
  }
}
</script>

<style lang="less" scoped>
.choiceTab{
  border: 1px solid #DDDDDD !important;
  color: #999999 !important;
  background-color: #F3F3F3 !important;
  cursor: default;
}
.selectedTab{
  cursor: default;
  background-color: #F0FFF2;
  border: 1px solid #59C264;
  border-radius: 12px;
  color: #59C264;
  min-width: 55px;
  font-size: 12px;
  padding: 6px 6px 6px 12px;
  box-sizing: border-box;
  line-height: 12px;
  text-align: center;
  margin-right: 8px;
}
.tab{
  cursor: pointer;
  background-color: #F0FFF2;
  border: 1px solid #59C264;
  border-radius: 12px;
  color: #59C264;
  min-width: 55px;
  font-size: 12px;
  padding: 6px 12px;
  box-sizing: border-box;
  line-height: 12px;
  text-align: center;
  margin-right: 13px;
  margin-bottom: 10px;
}
.tab_button{
  border: #4D78FF dashed 1px;
  line-height: 14px;
  width: 200px;
  color: #4D78FF;
  text-align: center;
  padding: 11px 15px;
  box-sizing: border-box;
  cursor: pointer;
}
.tab_button:hover{
  background-color: #d0ffff;
}
/deep/ .ql-editor{
  min-height: 480px;
}
/deep/ .ql-snow .ql-picker{
  height: 40px;
}
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}
::-webkit-scrollbar-button {
  display: none;
}
::-webkit-scrollbar-thumb {
  background: rgb(220 225 225 / 65%);
  cursor: pointer;
  border-radius: 4px;
}

/deep/ .ql{
  .ql-snow .ql-picker.ql-header,
  .ql-snow .ql-picker.ql-size {
    box-sizing: border-box;
    border: 1px solid #D2DBEA;
  }
  .ql-snow.ql-toolbar button:hover,
  .ql-snow .ql-toolbar button:hover,
  .ql-picker-item:hover {
    background: #F4F5F7;
  }
  .ql-picker-item {
    padding-left: 6px;
  }
  .ql-snow.ql-toolbar button.ql-active {
    background: #E7EBEF;
  }
  .ql-toolbar.ql-snow {
    margin: 0 auto;
  }

  .ql-snow .ql-color-picker .ql-picker-label svg, .ql-snow .ql-icon-picker .ql-picker-label svg{margin-bottom:-2px;}
  .ql-snow .ql-picker-label::before{position:relative;top:0px;}
  .ql-snow .ql-tooltip[data-mode=link] { left: 20px !important;}
  .ql-snow .ql-tooltip[data-mode=link]::before {content: "请输入链接地址:";}
  .ql-snow .ql-tooltip[data-mode=link] { left: 20px !important;}
  .ql-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-label, .ql-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-options{border-color: none; padding: 4px 0;}
  .ql-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-label{border-color: none; padding: 0 8px;}
  .ql-snow .ql-tooltip.ql-editing a.ql-action::after {
    border-right: 0px;
    content: '保存';
    padding-right: 0px;
  }

  .ql-snow .ql-tooltip[data-mode=video]::before {content: "请输入视频地址:";}

  .ql-snow .ql-picker.ql-size .ql-picker-label::before,
  .ql-snow .ql-picker.ql-size .ql-picker-item::before {content: '14px';}
  .ql-snow .ql-picker.ql-size .ql-picker-label[data-value=small]::before,
  .ql-snow .ql-picker.ql-size .ql-picker-item[data-value=small]::before {content: '10px';}
  .ql-snow .ql-picker.ql-size .ql-picker-label[data-value=large]::before,
  .ql-snow .ql-picker.ql-size .ql-picker-item[data-value=large]::before {content: '18px';}
  .ql-snow .ql-picker.ql-size .ql-picker-label[data-value=huge]::before,
  .ql-snow .ql-picker.ql-size .ql-picker-item[data-value=huge]::before {content: '32px';}

  .ql-snow .ql-picker.ql-size .ql-picker-label[data-value='10px']::before, .ql-snow .ql-picker.ql-size .ql-picker-item[data-value='10px']::before {content: '10px';}
  .ql-snow .ql-picker.ql-size .ql-picker-label[data-value='12px']::before, .ql-snow .ql-picker.ql-size .ql-picker-item[data-value='12px']::before {content: '12px';}
  .ql-snow .ql-picker.ql-size .ql-picker-label[data-value='14px']::before, .ql-snow .ql-picker.ql-size .ql-picker-item[data-value='14px']::before {content: '14px';}
  .ql-snow .ql-picker.ql-size .ql-picker-label[data-value='16px']::before, .ql-snow .ql-picker.ql-size .ql-picker-item[data-value='16px']::before {content: '16px';}
  .ql-snow .ql-picker.ql-size .ql-picker-label[data-value='18px']::before, .ql-snow .ql-picker.ql-size .ql-picker-item[data-value='18px']::before {content: '18px';}
  .ql-snow .ql-picker.ql-size .ql-picker-label[data-value='20px']::before, .ql-snow .ql-picker.ql-size .ql-picker-item[data-value='20px']::before {content: '20px';}
  .ql-snow .ql-picker.ql-size .ql-picker-label[data-value='22px']::before, .ql-snow .ql-picker.ql-size .ql-picker-item[data-value='22px']::before {content: '22px';}
  .ql-snow .ql-picker.ql-size .ql-picker-label[data-value='24px']::before, .ql-snow .ql-picker.ql-size .ql-picker-item[data-value='24px']::before {content: '24px';}
  .ql-snow .ql-picker.ql-size .ql-picker-label[data-value='26px']::before, .ql-snow .ql-picker.ql-size .ql-picker-item[data-value='26px']::before {content: '26px';}
  .ql-snow .ql-picker.ql-size .ql-picker-label[data-value='28px']::before, .ql-snow .ql-picker.ql-size .ql-picker-item[data-value='28px']::before {content: '28px';}
  .ql-snow .ql-picker.ql-size .ql-picker-label[data-value='30px']::before, .ql-snow .ql-picker.ql-size .ql-picker-item[data-value='30px']::before {content: '30px';}
  .ql-snow .ql-picker.ql-size .ql-picker-label[data-value='32px']::before, .ql-snow .ql-picker.ql-size .ql-picker-item[data-value='32px']::before {content: '32px';}
  .ql-snow .ql-picker.ql-size .ql-picker-label[data-value='34px']::before, .ql-snow .ql-picker.ql-size .ql-picker-item[data-value='34px']::before {content: '34px';}
  .ql-snow .ql-picker.ql-size .ql-picker-label[data-value='36px']::before, .ql-snow .ql-picker.ql-size .ql-picker-item[data-value='36px']::before {content: '36px';}
  .ql-snow .ql-picker.ql-header .ql-picker-item::before {font-size: 12px;font-weight: 400;color: #444444;}
  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="1"]::before {font-size: 28px;font-weight: 400;color: #444444;}
  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="2"]::before {font-size: 24px;font-weight: 400;color: #444444;}
  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="3"]::before {font-size: 20px;font-weight: 400;color: #444444;}
  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="4"]::before {font-size: 16px;font-weight: 400;color: #444444;}
  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="5"]::before {font-size: 14px;font-weight: 400;color: #444444;}
  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="6"]::before {font-size: 12px;font-weight: 400;color: #444444;}
  .ql-snow .ql-picker.ql-header .ql-picker-label::before {content: '正文';font-family: PingFangSC-Regular;font-weight: 400;font-size: 14px;color: #4B5D7B;}
  .ql-snow .ql-picker.ql-header .ql-picker-item::before {content: '正文';font-weight: 400;color: #444444;}
  .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="1"]::before,
  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="1"]::before {content: '标题1';}
  .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="2"]::before,
  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="2"]::before {content: '标题2';}
  .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="3"]::before,
  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="3"]::before {content: '标题3';}
  .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="4"]::before,
  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="4"]::before {content: '标题4';}
  .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="5"]::before,
  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="5"]::before {content: '标题5';}
  .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="6"]::before,
  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="6"]::before {content: '标题6';}

  // .ql-snow .ql-picker.ql-font .ql-picker-label::before,
  // .ql-snow .ql-picker.ql-font .ql-picker-item::before {content: '标准字体';}
  // .ql-snow .ql-picker.ql-font .ql-picker-label[data-value=serif]::before,
  // .ql-snow .ql-picker.ql-font .ql-picker-item[data-value=serif]::before {content: '衬线字体';}
  // .ql-snow .ql-picker.ql-font .ql-picker-label[data-value=monospace]::before,
  // .ql-snow .ql-picker.ql-font .ql-picker-item[data-value=monospace]::before {content: '等宽字体';}

  // .ql-snow .ql-picker-label:before, .ql-snow .ql-picker.ql-size .ql-picker-item:before, .ql-snow .ql-picker.ql-size .ql-picker-label:before{top:-7px}
}

</style>
